import React from 'react';

// Import images
import aboutTwoImg from '../../assets/images/artwer/project-5-buitentrap-nijverdal.jpg';
import aboutTwoImgWebp from '../../assets/images/artwer/project-5-buitentrap-nijverdal.webp';
import aboutTwoShape from '../../assets/images/shapes/about-two-shape-1.png';

// "Sinds 2012" — derive the years-of-experience figure instead of hardcoding it.
const YEARS_EXPERIENCE = new Date().getFullYear() - 2012;

const AboutTwo = () => {
  return (
    <section className="about-two" id="over">
      <div className="container">
        <div className="row">
          <div className="col-xl-6">
            <div
              className="about-two__left wow slideInLeft"
              data-wow-delay="100ms"
              data-wow-duration="2500ms"
            >
              <div className="about-two__img-box">
                <div className="about-two__img">
                  <picture>
                    <source srcSet={aboutTwoImgWebp} type="image/webp" />
                    <img src={aboutTwoImg} alt="Antislip op een buitentrap in Nijverdal — werk van ART-WER" width="825" height="1100" loading="lazy" />
                  </picture>
                </div>
                <div className="about-two__shape-1">
                  <img src={aboutTwoShape} alt="" />
                </div>
                <div className="about-two__count-box">
                  <div className="about-two__count-icon">
                    <span className="icon-wall"></span>
                  </div>
                  <div className="about-two__count-inner">
                    <div className="about-two__count count-box">
                      <div className="count-text">{YEARS_EXPERIENCE}</div>
                      <span className="about-two__count-plus">+</span>
                    </div>
                    <p className="about-two__count-text">Jaar ervaring</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-6">
            <div className="about-two__right">
              <div className="section-title text-left">
                <div className="section-title__tagline-box">
                  <span className="section-title__tagline">Even voorstellen</span>
                </div>
                <h2 className="section-title__title">
                  Over <span className="nowrap">ART-WER</span>
                </h2>
              </div>
              <p className="about-two__text">
                Een lekkend balkon, brokkelend beton of een galerijvloer die niet meer voldoet —
                vroeg of laat krijgt elk gebouw hiermee te maken. Bij <span className="nowrap">ART-WER</span> praat u van begin tot
                eind met dezelfde vakman: een aannemingsbedrijf en eenmanszaak sinds 2012 uit
                Biddinghuizen. Geen tussenlagen, geen onaangekondigd meerwerk — wél een vaste
                opleverdatum.
              </p>
              <ul className="about-two__progress-box list-unstyled">
                  <li>
                    <div className="about-two__progress">
                      <h3 className="about-two__progress-title">Persoonlijke uitvoering</h3>
                      <div className="bar">
                        <div className="bar-inner-one count-bar" data-percent="100%" style={{ width: '100%' }}>
                          <div className="count-text">100%</div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="about-two__progress">
                      <h3 className="about-two__progress-title">Heldere communicatie</h3>
                      <div className="bar">
                        <div className="bar-inner-two count-bar" data-percent="95%" style={{ width: '95%' }}>
                          <div className="count-text">95%</div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="about-two__progress">
                      <h3 className="about-two__progress-title">Op tijd opgeleverd</h3>
                      <div className="bar">
                        <div className="bar-inner-three count-bar" data-percent="98%" style={{ width: '98%' }}>
                          <div className="count-text">98%</div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
                <div className="about-two__btn-box">
                <a href="#contact" className="about-two__btn thm-btn-two">Plan een opname<span className="icon-dubble-arrow-right"></span></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutTwo;
